import React from 'react';
// import { useTranslation } from 'react-i18next';
import { Container, Link } from '@mui/material';
import Logo from 'src/assets/logos/logosyw.svg';
import { useNavigate } from 'react-router';
import MDUIButton from '../m3/button';
import styles from './topbar.module.css';

function Topbar() {
  // const { i18n } = useTranslation();
  const navigate = useNavigate();
  // const [language, setLanguage] = useState(i18n.language || 'en');

  // const toggleLanguage = () => {
  //   const newLang = language === 'en' ? 'fr' : 'en';
  //   i18n.changeLanguage(newLang);
  //   localStorage.setItem('i18nextLng', newLang);
  //   setLanguage(newLang);
  // };

  // we add this const temporary and will remove it and use states later when they decide to use other language rather than english
  const language = 'en';

  return (
    <div className={styles.topbarWrapper}>
      <Container>
        <div className={styles.topbarRow}>
          {/* Title */}

          <div className={styles.topbarTitleGroup}>
            <Link
              onClick={() => {
                navigate('/');
              }}
            >
              <img
                src={Logo}
                className={styles.logoImage}
                alt="Logo"
                style={{
                  cursor: 'pointer'
                }}
              />
            </Link>
          </div>
          {/* Right Actions */}
          <div className={styles.topbarActions} id="topbar-actions">
            {/* Language Button */}

            <MDUIButton
              icon="language"
              // endIcon="keyboard_arrow_down"
              variant="outlined"
              className={styles.languageButtonContent}
              // onClick={toggleLanguage}
              style={{
                height: '44px',
                gap: '6px',
                color: 'var(--color-Schemes-On-Secondary-Container,#010101)',
                backgroundColor: 'transparent',
                border: '1px solid #010101'
              }}
            >
              <span className={styles.languageText}>
                {language?.toUpperCase()}
              </span>
            </MDUIButton>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Topbar;
